import { Button } from "@shared/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@shared/ui/dialog";
import React from "react";

const AddMemberModal = ({
  openAddMemberModal,
  setOpenAddMemberModal,
}: {
  openAddMemberModal: boolean;
  setOpenAddMemberModal: (value: boolean) => void;
}) => {
  const handleSubmit = async () => {
    // Handle form submission logic here
    setOpenAddMemberModal(false);
  };

  const handleCancel = () => {
    setOpenAddMemberModal(false);
  };
  return (
    <div>
      <Dialog open={openAddMemberModal} onOpenChange={setOpenAddMemberModal}>
        <DialogContent className="max-w-xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-xl">Add New Member</DialogTitle>
            <DialogDescription>
              Add a new member to the recipient list.
            </DialogDescription>
          </DialogHeader>

          <div className="mt-4"></div>

          <DialogFooter>
            <Button variant="outline" onClick={handleCancel}>
              Cancel
            </Button>
            <Button onClick={handleSubmit}>Create Signature</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AddMemberModal;
